const env = process.env.NODE_ENV
// var url = 'http://192.168.11.103:19091/aicourse';
var url = 'https://ouragejava.aojuai.com/aicourse'; 
// 新服务
const config = {
  development:{
    // baseURL :url//本地
    baseURL :url, //线上 
   
  },
  production:{
     baseURL :'https://ouragejava.aojuai.com/aicourse',

  }
}
export default {  
  baseURL:config[env].baseURL,
}